/*
 * ************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *   Copyright 2021 Adobe Systems Incorporated
 *   All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 * ************************************************************************
 */

import React from 'react';
import { connect } from '@airglow/store-redux';
import { validationPlugins } from '../../casing/data/feature.flags';
import SettingsView from '../../ui/settings-view';
import ManageValidationContainer from './manage.validation.plugins.container';
import ManageViewContainer from './manage.view.plugins.container';
import { saveValidationPluginConfig } from '../actions';
import {
  settingsOpen,
  settingsView
} from '../data/prefabs';

const mapState = (state, props) => ({
  enableValidationPlugins: validationPlugins(state),
  open: settingsOpen.isOpen(state),
  selectedView: settingsView.value(state),
  validationPluginsWidget: <ManageValidationContainer {...props} />,
  viewPluginsWidget: <ManageViewContainer {...props} />
});

const mapHandlers = dispatch => ({
  onClose: () => {
    dispatch(saveValidationPluginConfig());
    dispatch(settingsOpen.turnOffAction);
  },
  onSelectView: v => dispatch(settingsView.changeAction(v))
});

export default connect(mapState, mapHandlers)(SettingsView);
